// contexts/ToastContext.jsx
import { createContext, useCallback, useContext, useRef, useState } from "react";

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const nextId = useRef(0);

  const dismiss = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const show = useCallback((msg, type = "success") => {
    // Monotonic counter → always-unique id. Date.now() alone collides when two
    // toasts fire in the same millisecond (e.g. StrictMode's double-invoked effects
    // both hitting a failing request), which produced duplicate React keys and left a
    // toast stuck on screen because the cleanup couldn't reconcile it.
    const id = ++nextId.current;
    setToasts((prev) => [...prev, { id, msg, type }]);
    setTimeout(() => dismiss(id), 3200);
  }, [dismiss]);

  return (
    <ToastContext.Provider value={show}>
      {children}
      <div className="toast-container">
        {toasts.map((t) => (
          <div key={t.id} className={`toast toast-${t.type}`}>
            <span className="toast-icon">
              {t.type === "success" ? "✓" : t.type === "error" ? "✕" : "ℹ"}
            </span>
            <span style={{ flex: 1 }}>{t.msg}</span>
            <button
              onClick={() => dismiss(t.id)}
              aria-label="Dismiss"
              style={{
                background: "none", border: "none", color: "var(--text-dim)",
                cursor: "pointer", fontSize: 12, lineHeight: 1, padding: 2, marginLeft: 4,
              }}
            >
              ✕
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);
